import { gql } from '@apollo/client';
import SearchResultFragment from '@/components/common/UniversalSearch/apollo/SearchResult.fragment';

const SearchFor = gql`
  ${SearchResultFragment}

  query SearchFor($query: String!, $filterCategories: [SearchResultCategory!], $page: Int, $perPage: Int) {
    search(query: $query, filterCategories: $filterCategories, page: $page, perPage: $perPage) {
      ...SearchResultFragment
    }
  }
`;

export default SearchFor;
